package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

private val segmented = Bem("admin-segmented-control")

/** Mutually exclusive views of the same content, such as "Schreiben" and "Vorschau"; not for values that are saved. */
@Composable
fun <T> AdminSegmentedControl(
    options: List<Pair<T, String>>,
    selected: T,
    onSelect: (T) -> Unit,
    label: String,
) {
    Div({
        classes(segmented.block)
        attr("role", "group")
        attr("aria-label", label)
    }) {
        options.forEach { (value, text) ->
            Button({
                type(ButtonType.Button)
                classes(segmented.element("option").className)
                attr("aria-pressed", (value == selected).toString())
                onClick { onSelect(value) }
            }) { Text(text) }
        }
    }
}
